import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModule } from 'src/app/material.module';
import { CerereTypeComponent } from './cerere-type.component';
import { AddCerereTypeComponent } from './add-cerere-type/add-cerere-type.component';
import { EditCerereTypeComponent } from './edit-cerere-type/edit-cerere-type.component';
import { CerereTypeFunctieManagementComponent } from './cerere-type-functie-management/cerere-type-functie-management.component';

@NgModule({
    declarations: [
        CerereTypeComponent,
        AddCerereTypeComponent,
        EditCerereTypeComponent,
        CerereTypeFunctieManagementComponent,
    ],
    imports: [
        CommonModule, 
        ReactiveFormsModule, 
        FormsModule, 
        MaterialModule,
        DragDropModule
    ],
    exports: [
        CerereTypeComponent,
        AddCerereTypeComponent,
        EditCerereTypeComponent,
        CerereTypeFunctieManagementComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RequestTypesModule { }
